import posthog from 'posthog-js'
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="post-hog"
export default class extends Controller {
  static values = {
    apiKey: String,
    apiHost: String,
    identification: Object
  }

  connect() {
    if (!this.hasApiKeyValue || !this.apiKeyValue) return

    posthog.init(this.apiKeyValue, {
      api_host: this.apiHostValue || 'https://eu.i.posthog.com',
      custom_campaign_params: ['ref'],
      person_profiles: 'identified_only',
      capture_pageview: 'history_change'
    })

    if (this.hasIdentificationValue && Object.keys(this.identificationValue).length) {
      const { id, email, name } = this.identificationValue
      posthog.identify(id.toString(), { email, name })
    }
  }
}
